// import moment from 'moment';
// import { Link } from 'react-router-dom';
import styled from 'styled-components';
import NativeNumber from '../../component/Numeral';
// import { defaultImage } from '../../methods/utils/general-utils';

interface IUserItem {
	item: any;
	index: any;
}

const Style = styled.div`
	padding: 20px;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 40px 1fr 1fr 1fr 100px 1fr 90px;
	gap: 4px;

	& .label {
		font-size: 13px;
		color: #808080;
		font-style: italic;
	}

	& .balance {
		display: flex;

		& img {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
`;

const User = ({ item, index }: IUserItem) => (
	<Style>
		<div>{index}</div>
		<div className="balance">
			<p>{item?.user?.email}</p>
			{/* <img alt="icon" src={item.currencyId?.iconUrl || defaultImage} />
			<p>
				<strong>
					<NativeNumber value={item.balance} /> {item.currencyId?.symbol}
				</strong>
			</p> */}
		</div>
		<div>
			<p>{item?.user?.fullName}</p>
			{/* <Link to={`/user-profile/${item.userId}`}>@{item.userEmail}</Link>
			<p className="label">Customer</p> */}
		</div>
		<div>
			<strong>
				<NativeNumber value={item?.amount} decimalPlaces={2} />
			</strong>
		</div>
		<div>
			<NativeNumber value={item?.nairaRate} decimalPlaces={2} />
		</div>
		<div>
			<strong>
				<NativeNumber value={item?.salaryInNaira} decimalPlaces={2} />
			</strong>
		</div>
		<div>
			<p>{item?.status}</p>
		</div>
	</Style>
);

export default User;
